
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { AssignmentEntry } from '@/types';
import UtilsMixin from '@/mixins/UtilsMixin.vue';

@Component
export default class AssignmentEntryItem extends Mixins(UtilsMixin) {
  @Prop({ type: Object, required: true }) readonly entry!: AssignmentEntry;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: Boolean, default: false }) readonly standalone!: boolean;
  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean;

  get statusColor(): string {
    if (this.entry.assigned === 'done') return 'green';
    if (this.entry.assigned === 'todo') return 'orange';
    if (this.entry.assigned === 'na') return 'grey';
    return 'orange';
  }

  get statusLabel(): string {
    if (this.entry.assigned === 'done') return 'Assegnato';
    if (this.entry.assigned === 'na') return 'Non applicabile';
    return 'Da assegnare';
  }

  get standaloneAssigneeName(): string | null {
    if (this.entry.multipleAssignees) {
      const names = this.entry.assignees
        .map((a) => a.assigneeName || 'Non definito')
        .join(', ');
      return names || null;
    }
    return this.entry.assigneeName || null;
  }

  get tooltipText(): string {
    const { entry } = this;
    if (entry.multipleAssignees && entry.assignees.length > 0) {
      const lines = entry.assignees.map((a) => {
        const name = a.assigneeName || 'Non definito';
        const st = a.status === 'done' ? 'confermato' : 'da confermare';
        return `${name} (${st})`;
      });
      return `${entry.label}:\n${lines.join('\n')}`;
    }

    if (entry.assigned === 'done') return `${entry.label} (assegnato)`;
    if (entry.assigned === 'na') return `${entry.label} (non applicabile)`;

    return entry.assigneeName
      ? `${entry.label} (da assegnare)`
      : `${entry.label} (non definito, da assegnare)`;
  }

  get statusText(): string {
    const { entry } = this;
    if (entry.multipleAssignees) {
      if (entry.assigned === 'na') return 'Non applicabile';
      if (entry.assignees.length === 0) return 'Da assegnare';
      const names = entry.assignees
        .map((a) => a.assigneeName || 'Non definito')
        .join(', ');
      return names;
    }

    if (entry.assigned === 'done') {
      return entry.assigneeName || 'Non definito';
    }

    if (entry.assigned === 'na') return 'Non applicabile';

    return entry.assigneeName ?? 'Da assegnare';
  }
}
